import { useCallback, useMemo } from "react";
import * as React from "react";

import { ActionItem } from "@/common/ActionItem";
import { useToggleGuestPaymentsModule } from "@/api";
import { ParkingProperty } from "@/types";
import { useDialog } from "@/lib/contexts/dialog";
import { useDrawerNav } from "@/common/AppDrawer";

interface Props {
  property: ParkingProperty;
  onSuccess: () => void;
}

export const ToggleGuestPaymentModuleAction: React.FC<
  React.PropsWithChildren<Props>
> = ({ property, onSuccess }) => {
  const { confirm } = useDialog();
  const drawer = useDrawerNav();

  const [toggleGuestPayments] = useToggleGuestPaymentsModule();

  const enabled = useMemo(
    () => property?.guest_parking_payments_module_enabled ?? false,
    [property]
  );

  const title = useMemo(
    () => `${enabled ? "Disable" : "Enable"} Guest Payments Module`,
    [enabled]
  );

  const color = useMemo(() => (enabled ? "error" : "primary"), [enabled]);

  const handlePress = useCallback(async () => {
    if (enabled) {
      const confirmed = await confirm({
        title: "Disable Guest Payments Module",
        confirmText: "Disable",
        confirmType: "destructive",
        description:
          "Are you sure? Disabling this will disable all guest payment functionality at this community.",
      });

      if (confirmed) {
        await toggleGuestPayments({
          property: {
            ...property,
            guest_parking_payments_module_enabled: false,
          },
        });
        onSuccess();
      }
    } else {
      drawer.push("createPaymentConfiguration", { propertyId: property.id });
    }
  }, [onSuccess, property, enabled]);

  return <ActionItem onPress={handlePress} title={title} color={color} />;
};
